import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 3rem;

        @media ${theme.breakpoints.medium.media} {
            margin-top: 5rem;
        }

        @media ${theme.breakpoints.large.media} {
            margin-top: 7rem;
        }
    `}
`;

export const Heading = styled.h1`
    ${({ theme }) => css`
        margin: 0 0 1rem 0;

        @media ${theme.breakpoints.large.media} {
            margin: 0;
        }
    `}
`;

export const GreyText = styled.span`
    ${({ theme }) => css`
        color: ${theme.colors.secondary.tints[1].hex};
        font-weight: lighter;
    `}
`;

export const Detail = styled.span`
    ${({ theme }) => css`
        display: block;

        @media ${theme.breakpoints.large.media} {
            display: inline;
            margin-left: 0.25rem;
        }
    `}
`;

export const SubHeading = styled.p`
    ${({ theme }) => css`
        margin: 0 0 0.5rem 0;
        line-height: 1.75rem;
        font-size: 1.25rem;
        flex: 1 0 0;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.5rem;
        }
    `}
`;

export const VideoCaption = styled.p`
    ${({ theme }) => css`
        margin: 0.25rem 0 0.5rem 0;
        color: ${theme.colors.secondary.tints[1].hex};

        @media ${theme.breakpoints.medium.media} {
            order: 1;
            margin: 0.5rem 0 1rem 0;
        }

        @media ${theme.breakpoints.medium.media} {
            margin: 0.5rem 0 0.5rem 0;
        }
    `}
`;
